import React from 'react';
import styles from './FormItem.module.scss';

type Props = {
    flexProperties?: boolean
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const FormItem: React.FC<Props> = ({ children, flexProperties = false, ...props }: Props) => {

    return (
        <div
            {...props}
            className={`${styles.formItem} ${props.className || ''} ${(flexProperties ? styles.flexProperties : '')}`}
        >
            {children}
        </div>
    );
}

export default FormItem;
